import { ValidationType } from '@enums';
import { createValidationSchema } from '@utils';
import { VALIDATION_LIMITS } from '@constants';

export const CREATE_USER_ACCOUNT_SCHEMA = createValidationSchema({
  firstname: {
    required: true,
    pattern: ValidationType.NAME,
    minLength: VALIDATION_LIMITS.NAME_MIN_LENGTH,
    maxLength: VALIDATION_LIMITS.NAME_MAX_LENGTH,
  },
  lastname: {
    required: true,
    pattern: ValidationType.NAME,
    minLength: VALIDATION_LIMITS.NAME_MIN_LENGTH,
    maxLength: VALIDATION_LIMITS.NAME_MAX_LENGTH,
  },
  username: {
    required: true,
    pattern: ValidationType.EMAIL,
  },
  password: {
    required: true,
    minLength: VALIDATION_LIMITS.MIN_PASSWORD_LENGTH,
  },
  confirm_password: {
    required: true,
    customRule: {
      validator: ({ value, formData }) => value === formData.password,
      message: 'validation:changePassword.passwordsMustMatch',
    },
  },
});
